import { environment } from '../environments/environment';

export class Config {
      public ssoUrl = '/sso/api'
      public baseUrl = '';
      public localUrl = '';
      public ssoClientUrl = 'https://sso.webfactoryde.com/login?targetUrl=http://stubs.webfactoryde.com/';
      constructor() {
            if (!environment.ssoMode) {
                  this.baseUrl = this.localUrl;
            }
      }
}





// WEBPACK FOOTER //
// ./src/app/app.config.ts